import React from 'react';
import { render as prerender } from 'react-snapshot';
import { render } from 'react-dom';
import App from './components/App';
import './styles/_main.scss';

const root = document.getElementById('root');

if (process.env.NODE_ENV === 'development') {
  render(<App />, root)
} else {
  prerender(<App />, root)
}
